// Sometimes -9999 is used as no data, sometimes null.

// We also return false for undefined, in case a property is sometimes
// completely missing, as well as NaN to protect against bugs.

export function isValidData(value: number | null | undefined): value is number {
  return value !== -9999 && value !== null && value !== undefined && !Number.isNaN(value);
}

export function forceValidOrNull(values: (number | null | undefined)[]): (number | null)[] {
  return values.map((value) => (isValidData(value) ? value : null));
}
